import React from "react";
import { useState, useEffect, useRef } from "react";
type Props = {
  ConfirmationObject: {
    ShowPopup: boolean;
    Heading: string;
    Message: string;
    ID: number;
    SelectedID: number;
  };
  ConfirmationCallBack: any;
};
function Confirmation(props: Props) {
  const [ShowPopup, setShowPopup] = useState(
    props.ConfirmationObject.ShowPopup
  );
  function ClosePopUp(value:boolean) {
    props.ConfirmationCallBack({ show: false,isConfirm:value,ID:props.ConfirmationObject.ID,SelectedID:props.ConfirmationObject.SelectedID});
  }
  return (
    <div>
      {props.ConfirmationObject.ShowPopup && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>{props.ConfirmationObject.Heading}</h3>
                <a className="close-help" onClick={() => ClosePopUp(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="popup-message">
                <span
                  dangerouslySetInnerHTML={{
                    __html: props.ConfirmationObject.Message,
                  }}
                ></span>
              </div>
              <div className="help-btns">
                <a onClick={() => ClosePopUp(false)}>No</a>
                <a onClick={() => ClosePopUp(true)}>Yes</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Confirmation;
